import React from "react";
import { observer } from "mobx-react";
import {
  Switch as SwitchContext,
  Redirect,
  withRouter,
  RouteComponentProps,
} from "react-router-dom";

import AuthStore from "stores/AuthStore";

import Container from "components/Layout/Container";
import Header from "components/Layout/Header";
import PublishButton from "components/PublishButton";

import Recipes from "./Recipes/Recipes";
import RecipeDetails from "./Recipes/RecipeDetails";

import { PrivateRoute } from "navigation/Switch";

import ROUTES from "navigation/routes";

type Props = RouteComponentProps & {};

@observer
class ContentNutrition extends React.Component<Props> {
  onPublishAllContent = () => {};

  render() {
    return (
      <Container header={<Header controls={<PublishButton />} />}>
        <SwitchContext>
          <PrivateRoute
            path={ROUTES.CONTENT_NUTRITION_RECIPES}
            component={Recipes}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_NUTRITION_RECIPES}
            exact
          />
          <PrivateRoute
            path={ROUTES.CONTENT_NUTRITION_RECIPE_DETAILS}
            component={RecipeDetails}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_NUTRITION_RECIPES}
            exact
          />

          <Redirect to={ROUTES.CONTENT_NUTRITION_RECIPES} />
        </SwitchContext>
      </Container>
    );
  }
}

export default withRouter(ContentNutrition);
